import { Associative } from './types';

export const ENDPOINT_DASHBOARD_COUNTERS = `/solidarity/dashboard/counters`;
export const ENDPOINT_DASHBOARD_DEMANDS_VS_VOLUNTEERS_TYPOLOGIES =
  '/solidarity/dashboard/demands_vs_cards';
export const ENDPOINT_DASHBOARD_DEMANDS_OVER_TIME =
  '/solidarity/dashboard/demands';
export const ENDPOINT_DASHBOARD_VOLUNTEERS_OVER_TIME =
  '/solidarity/dashboard/cards';
export const ENDPOINT_DASHBOARD_REGISTRATIONS_OVER_TIME =
  '/solidarity/dashboard/user/registration';
export const ENDPOINT_DASHBOARD_CONNECTIONS_OVER_TIME =
  '/solidarity/dashboard/user/connexion';
export const ENDPOINT_DASHBOARD_PUBLICATION_TYPES_INFORMATION_OVER_TIME = '/solidarity/dashboard/publications?labels[]=information&labels[]=event&labels[]=poll&is_network=false';
export const ENDPOINT_DASHBOARD_PUBLICATION_NETWORK_TYPES_INFORMATION_OVER_TIME = '/solidarity/dashboard/publications?labels[]=information&labels[]=event&labels[]=poll&is_network=true';
export const ENDPOINT_DASHBOARD_PUBLICATION_TYPES_INFORMATION_OVER_TIME_COMMUNITIES = '/solidarity/dashboard/publications?labels[]=information&labels[]=event&labels[]=poll&without_parent=true';
export const ENDPOINT_DASHBOARD_CHAT_STATS = '/stats';
export const ENDPOINT_DASHBOARD_PUBLICATION_TYPES_WELLBEING_OVER_TIME =
  '/solidarity/dashboard/publications?labels[]=wellbeing';
export const ENDPOINT_DASHBOARD_PUBLICATION_TYPES_HELP_OVER_TIME =
  '/solidarity/dashboard/publications?labels[]=need_help&labels[]=offer_help';
export const ENDPOINT_DASHBOARD_GENDER_REPARTITION =
  '/solidarity/dashboard/user/gender';
export const ENDPOINT_DASHBOARD_AGE_REPARTITION =
  '/solidarity/dashboard/user/age';

/* Demands and Volunteer origin list */
export const DEMANDS_ORIGIN_LIST: { [originKey: string]: string } = {
  phone_in: 'Appel entrant',
  phone_out: 'Appel sortant',
  ensembl: "Ensembl'",
  ensembl_association: "Voisins d'à côté",
  digital_conviviality_card: 'Fiche de convivialité numérique',
  paper_conviviality_card: "Fiche d'entraide papier",
  other: 'Autre',
};

export const DEMANDS_ORIGIN_LIST_FOR_NATIONAL: {
  [originKey: string]: string;
} = {
  phone_in: 'Appel entrant',
  phone_out: 'Appel sortant',
};

export const DEMANDS_STATUS: { [originKey: string]: string } = {
  in_progress: 'En cours',
  resolved: 'Résolu',
  unresolved: 'Non résolu',
};

export const DEMAND_RESOLVED = 'resolved';
export const DEMAND_UNRESOLVED = 'unresolved';

/* Civility */
export const CIVILITIES = {
  mme_title: 'Femme',
  mr_title: 'Homme',
};

export const CIVILITIES_ABBREVIATIONS: Associative = {
  mme_title: 'Mme.',
  mr_title: 'M.',
};

/* Form validations errors messages */
export const VALIDATION_ERROR_MESSAGES = {
  required: 'Veuillez renseigner ce champ',
  invalid_email: 'Veuillez renseigner une adresse mail valide',
  invalid_emails_list: 'Une ou plusieurs adresses mails ne sont pas valides',
  pattern: 'Veuillez renseigner une valeur valide',
  phone:
    'Veuillez renseigner votre numéro de téléphone avec un format valide (ex : +33756634467 ou 0756634467)',
  length: "La longeur du champ n'est pas valide",
  min: "La longeur minimale n'est pas atteinte",
  max: 'La longeur maximale est dépassée',
  len: 'Veuillez ne pas dépasser la limite de ce champ',
  password:
    'Le mot de passe doit comporter au moins 8 caractères, dont 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.',
};

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\[\]{};':"\\|,.<>\/?]).{8,}$/;

export const MAIL_ADDRESS_PATTERN =
  /^[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]*\.[a-zA-Z]+$/i;
export const PHONE_PATTERN =
  /^(0|\+33|\+533|\+590|\+594|\+262|\+596|\+687|\+689)[1-9]([-. ]?[0-9]{2}){4}$/i;

export const CATEGORIES: {
  [key: string]: {
    displayName: string;
    color: string;
  };
} = {
  'category.solidarity.discuss': {
    displayName: 'Visite de courtoisie',
    color: '#880015',
  },
  'category.solidarity.diy': {
    displayName: 'Petits travaux',
    color: '#865BBD',
  },
  'category.solidarity.groceries': {
    displayName: 'Aide aux courses',
    color: '#C00000',
  },
  'category.solidarity.walk': {
    displayName: 'Accompagnement',
    color: '#F07C42',
  },
  'category.solidarity.pet_sitting': {
    displayName: "Garde d'animaux",
    color: '#EF6565',
  },
  'category.solidarity.administrative': {
    displayName: 'Aide administrative',
    color: '#1A95C2',
  },
  'category.solidarity.mail_collection': {
    displayName: "Aide en cas d'absence",
    color: '#002060',
  },
  'category.solidarity.homework_help': {
    displayName: 'Cours particuliers',
    color: '#FFC000',
  },
  'category.solidarity.other': {
    displayName: 'Autre',
    color: '#bdbdbd',
  },
  'category.publication.help.case_of_absence': {
    displayName: `Aide en cas d'absence`,
    color: '#002060',
  },
  'category.customer.association.organization': {
    displayName: `Organisation`,
    color: '#F25B5B',
  },
  'category.customer.association.office': {
    displayName: `Bureau`,
    color: '#1A95C2',
  },
  'category.customer.association.field': {
    displayName: `Terrain`,
    color: '#4EC095',
  },
  'category.customer.association.undefined': {
    displayName: `Non renseigné`,
    color: '#7F8B90',
  },
  'category.solidarity.baby_sitting': {
    displayName: `Baby Sitting`,
    color: '#AF6DF8',
  },
  'category.solidarity.personal_assistance': {
    displayName: `Aide à la personne`,
    color: '#FCA78E',
  },
  'category.solidarity.move': {
    displayName: `Déménagement`,
    color: '#B40F7A',
  },
  'category.solidarity.computer_assistance': {
    displayName: `Aide informatique`,
    color: '#B40F7A',
  },
  'category.solidarity.housework': {
    displayName: `Ménage`,
    color: '#B4CE4D',
  },
};

export const CONTACT_EMAIL: string = 'support@ensembl.sbs';
export const PRIVACY_POLICY_URL: string =
  'https://demo.staging.ensembl.sbs/politique-de-confidentialite';

export const PUBLICATIONS_LABELS: {
  [rawLabel: string]: {
    label: string;
    mainColor: string;
    secondColor: string;
  };
} = {
  wellbeing: {
    label: 'Bien-être',
    mainColor: '#FF9966',
    secondColor: '#FFCCB2',
  },
  poll: {
    label: 'Sondage',
    mainColor: '#3BB88D',
    secondColor: '#CEF2E6',
  },
  message: {
    label: 'Message',
    mainColor: '#1A95C2',
    secondColor: '#DAF4FE',
  },
  nb_publication: {
    label: 'Total publications',
    mainColor: '#865BBD',
    secondColor: '#E5B5FF',
  },
  good_deal: {
    label: 'Bons plans',
    mainColor: '#865BBD',
    secondColor: '#E5B5FF',
  },
  need_help: {
    label: `Demande d'aide`,
    mainColor: '#f19101',
    secondColor: '#F1D5AC',
  },
  offer_help: {
    label: `Proposition d'aide`,
    mainColor: '#24acac',
    secondColor: '#d1e9eb',
  },
  help: {
    label: 'Coup de main',
    mainColor: '#3BB88D',
    secondColor: '#CEF2E6',
  },
  event: {
    label: 'Evènement',
    mainColor: '#F25959',
    secondColor: '#FFD6D6',
  },
  information: {
    label: 'Information',
    mainColor: '#1A95C2',
    secondColor: '#DAF4FE',
  },
  news: {
    label: 'Message',
    mainColor: '#1A95C2',
    secondColor: '#DAF4FE',
  },
  participation: {
    label: 'Intéractions',
    mainColor: '#865BBD',
    secondColor: '#FFCCB2',
  },
  publication_rate: {
    label: 'Taux de publication (%)',
    mainColor: '#FF9966',
    secondColor: '#FFCCB2',
  },
  'category.service.discuss': {
    label: 'Catégorie: Visite de courtoisie',
    mainColor: '#880015',
    secondColor: '#FFCCB2',
  },
  'category.service.diy': {
    label: 'Catégorie: Petits travaux',
    mainColor: '#865BBD',
    secondColor: '#FFCCB2',
  },
  'category.service.groceries': {
    label: 'Catégorie: Aide aux courses',
    mainColor: '#C00000',
    secondColor: '#FFCCB2',
  },
  'category.service.walk': {
    label: 'Catégorie: Accompagnement',
    mainColor: '#F07C42',
    secondColor: '#FFCCB2',
  },
  'category.service.pet_sitting': {
    label: "Catégorie: Garde d'animaux",
    mainColor: '#EF6565',
    secondColor: '#FFCCB2',
  },
  'category.service.administrative': {
    label: 'Catégorie: Aide administrative',
    mainColor: '#1A95C2',
    secondColor: '#FFCCB2',
  },
  'category.service.mail_collection': {
    label: "Catégorie: Aide en cas d'absence",
    mainColor: '#002060',
    secondColor: '#FFCCB2',
  },
  'category.service.homework_help': {
    label: 'Catégorie: Cours particuliers',
    mainColor: '#FFC000',
    secondColor: '#FFCCB2',
  },
  'category.service.other': {
    label: 'Catégorie: Autre',
    mainColor: '#bdbdbd',
    secondColor: '#FFCCB2',
  },
  'category.service.baby_sitting': {
    label: 'Catégorie: Baby Sitting',
    mainColor: '#AF6DF8',
    secondColor: '#FFCCB2',
  },
  'category.service.personal_assistance': {
    label: 'Catégorie: Aide à la personne',
    mainColor: '#FCA78E',
    secondColor: '#FFCCB2',
  },
  'category.service.move': {
    label: 'Catégorie: Déménagement',
    mainColor: '#B40F7A',
    secondColor: '#FFCCB2',
  },
  'category.service.computer_assistance': {
    label: 'Categorie: Aide informatique',
    mainColor: '#B40F7A',
    secondColor: '#FFCCB2',
  },
  'category.service.housework': {
    label: 'Categorie: Ménage',
    mainColor: '#B4CE4D',
    secondColor: '#FFCCB2',
  },
  participation_rate: {
    label: 'Taux de participation (%)',
    mainColor: '#1A95C2',
    secondColor: '#DAF4FE',
  },
  connection_rate: {
    label: 'Taux de connexion (%)',
    mainColor: '#1A95C2',
    secondColor: '#DAF4FE',
  },
  babysitting: {
    label: 'Babysitting',
    mainColor: '#865BBD',
    secondColor: '#E5B5FF',
  },
  activity: {
    label: 'Activités',
    mainColor: '#3BB88D',
    secondColor: '#CEF2E6',
  },
  comment: {
    label: 'Commentaires',
    mainColor: '#000000',
    secondColor: '#000000',
  },
  alert: {
    label: 'Alerte',
    mainColor: '#FF9966',
    secondColor: '#FFCCB2',
  },
  building_life: {
    label: `Vie de l'immeuble`,
    mainColor: '#000000',
    secondColor: '#000000',
  },
};

/** Static Google map api */
export const STATIC_MAP_URL =
  'https://maps.googleapis.com/maps/api/staticmap?zoom=15&size=900x350&maptype=roadmap&language=fr';

/* Period Translater */
export const PERIOD_TRANSLATOR: Associative = {
  day: 'Jour',
  week: 'Semaine',
  month: 'Mois',
  year: 'Année',
};

export const CUSTOMER_TYPES = {
  DEPARTMENT: 'department',
  CCAS: 'ccas',
  ASSOCIATION: 'association',
  HABITAT: 'real_estate_player',
  NATIONAL: 'national',
  SAAD: 'saad',
};

export const URL_SUBMENU = {
  publications: [
    'brouillons',
    'suggestions-de-post',
    'programmation-publications',
    'publications',
    'publish',
  ],
  annuaire: ['voisins'],
  documents: ['ensembl', 'reseau', 'communautes', 'boite-a-outils', 'mon-stockage'],
  administration: [
    'parametres-de-l-entite',
    'parametres-profil',
    'parametres-avances',
  ],
};

export const DEFAULT_INVITATION_SUBJECT =
  'Invitation à rejoindre le groupe des partenaires solidaires';

export const DEFAULT_INVITATION_BODY = `Bonjour,
\nNous sommes ravis de vous inviter à rejoindre notre dispositif en ligne permettant de mobiliser la communauté au service des personnes fragilisées.
\nCe dispositif innovant repose sur l’outil de pilotage proposé par Ensembl’ groupe, le premier réseau social de proximité. Il permet de remonter des besoins de personnes fragilisées, de trouver des utilisateurs bénévoles ainsi que de nous coordonner entre acteurs de la solidarité.
\nNous vous invitons donc à rejoindre l’espace privé dédié à nos échanges et à la coordination entre acteurs de la solidarité. Il vous permet également de remonter des besoins et des propositions d’aide.
\nPour toute question, n’hésitez pas à nous contacter directement par téléphone.
\nA bientôt,`;

export const DEFAULT_INVITATION_BODY_FOOTER =
  'Merci de ne pas répondre à cet email. En cas de besoin, contacter support@ensembl.sbs';

/** Media screen */
export const SMALL_SCREEN_MAX_WIDTH = 768;
export const LARGE_SCREEN_MIN_WIDTH = 769;

/* Google Tag Manager ID */
export const GTM_ID = 'GTM-PD969MP';

/* Types d'alerte */
export const ALERT_TYPES: {
  [key: string]: {
    displayName: string;
    color: string;
    media_url: string;
    id: string;
  };
} = {
  'category.alert.heat_wave': {
    displayName: 'Alerte canicule',
    color: '#f25b5b',
    media_url:
      'https://staging.media.ensembl.sbs/original/categories/alert/category.alert.heat_wave.jpg',
    id: '4b4bd86e-730b-11e8-afc4-4fcf526e873d',
  },
  'category.alert.extreme_cold': {
    displayName: 'Alerte grand froid',
    color: '#389ecc',
    media_url:
      'https://staging.media.ensembl.sbs/original/categories/alert/category.alert.extreme_cold.jpg',
    id: '4b4c7058-730b-11e8-afc4-6f1cf6db5768',
  },
  'category.alert.flood': {
    displayName: 'Alerte inondation',
    color: '#78B832',
    media_url:
      'https://staging.media.ensembl.sbs/original/categories/alert/category.alert.flood.jpg',
    id: '4b4c260c-730b-11e8-afc4-43d5d629681d',
  },
  'category.alert.other': {
    displayName: 'Autre',
    color: '#78B832',
    media_url:
      'https://staging.media.ensembl.sbs/original/categories/alert/category.alert.other.jpg',
    id: '4b4cc472-730b-11e8-afc4-ef151f96892a',
  },
};

/* Number of displayed tags in volunteer card */
export const NUMBER_OF_DISPLAYED_TAGS: number = 3;

export const USER_ROLES: { [rawRole: string]: string } = {
  administrator: 'Administrateur',
  reporter: 'Consultant',
  agent: 'Agent',
  messaging: 'Community manager',
};

/* Rôles proposés à l'invitation et au changement de rôle. « Community manager »
   n'en fait plus partie : l'API ne lui donne aucun droit de gestion. Son libellé
   reste dans USER_ROLES pour les comptes qui l'ont déjà. */
export const ASSIGNABLE_USER_ROLES = ['administrator', 'reporter', 'agent'];

export const CUSTOMER_ROLES = {
  administrator: 'administrator',
};

export const CHANNEL = {
  publication: 'publication',
  privateMessage: 'private_message',
};

export const DATE_PICKER_INFO_TEXT =
  'Si vous souhaitez que votre campagne soit visible le jour même, il faudra la soumettre avant 11h';

export const PUBLICATIONS_PER_PAGE = 10;

export const DOM_ENSEMBL = [
  'beauvais',
  'digne-les-bains',
  'metz',
  'pau',
  'saint-gratien',
  'saint-quentin',
  'vierzon',
  'charleville-mezieres',
  'la-possession',
  'epinay-sur-orge',
  'laneuveville-devant-nancy',
  'mont-saint-aignan',
  'moulins',
  'bourges',
  'kourou',
  'sinnamary',
  'iracoubo',
];

export const COMMUNES_DES_SAVANES = ['kourou', 'sinnamary', 'iracoubo'];

export const URL_DOM_ENSEMBL = 'https://dom.ensembl.sbs/';
export const URL_ENSEMBL = 'https://app.ensembl.sbs';

export const DISPLAY_ICONS_MENU = [
  'publications',
  'programmation-publications',
  'suggestions-de-post',
  'annuaire',
  'documents',
  'administration',
];

export const RECURRENT = {
  daily: 'everyDay',
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly',
};

export const TRIGGER = {
  joinGroup: 'onJoinGroup',
  inscription: 'onRegistrationUser',
  date: 'timer',
};

export const TARGET = {
  town: 'town',
  group: 'group',
  district: 'district',
};
